import { apiClient, type ApiResponse } from './client'

export type MathHeadRunStatus = 'READY' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'

export interface MathHeadLaunchRequest {
  /** Exact origin of the page hosting the BIGGO iframe (window.location.origin). */
  embedOrigin: string
}

/** Learner launch/resume: `iframeUrl` carries a one-time BIGGO ticket (5 min TTL). */
export interface MathHeadLaunchResponse {
  assessmentId: number
  runId: number
  attemptId: string
  roundNo: number
  iframeUrl: string
  status: MathHeadRunStatus
  startedAt: string | null
  deadline: string | null
}

export interface MathHeadConfirmResponse {
  runStatus: MathHeadRunStatus
  segmentStatus: 'AVAILABLE' | 'IN_PROGRESS' | 'COMPLETED' | 'EXEMPTED'
  assessmentStatus: 'ACTIVE' | 'RESOLVED'
  nextAssessmentActivated: boolean
  /** true when BIGGO could not be reached and the response reflects local state only. */
  degraded: boolean
}

export const cumulativeAssessmentApi = {
  launchMathHead: (assessmentId: number, body: MathHeadLaunchRequest) =>
    apiClient.post<ApiResponse<MathHeadLaunchResponse>>(
      `/lc/my/cumulative-assessments/${assessmentId}/math-head/launch`,
      body,
    ),

  confirmMathHead: (assessmentId: number, runId: number) =>
    apiClient.post<ApiResponse<MathHeadConfirmResponse>>(
      `/lc/my/cumulative-assessments/${assessmentId}/math-head/runs/${runId}/confirm`,
    ),
}
